import { useActiveProductSlice } from './useActiveProductSlice';
interface IUseSpacingBetweenProductCard {
  spacingClass: string | null;
  breakpoints: {};
  defaultSlidePerView: number | 'auto';
  defaultSpaciBetween: number;
  spacing_between_card: ISpaceType['spacing'];
  isProductCardLargImage: boolean;
}

interface ISpaceType {
  spacing: 'small' | 'medium' | 'large' | 'none';
}

const useSpacingBetweenProductCard = (): IUseSpacingBetweenProductCard => {
  const { spaceBetween, isLargeCard } = useActiveProductSlice();

  const spacing = spaceBetween as ISpaceType['spacing'];
  const isProductCardLarge = isLargeCard;

  const getClass = (spacing: ISpaceType['spacing']) =>
    `collections_${spacing ? spacing : 'none'}_spacing`;

  const spacingValues = {
    none: {
      default: 0,
      sm: 0,
      md: 0,
      xl: 0,
      xxl: 0,
    },
    small: {
      default: 6,
      sm: 6,
      md: 10,
      xl: 14,
      xxl: 14,
    },
    medium: {
      default: 8,
      sm: 10,
      md: 12,
      xl: 16,
      xxl: 16,
    },
    large: {
      default: 8,
      sm: 12,
      md: 16,
      xl: 20,
      xxl: 20,
    },
  };

  const selectedSpacing = spacingValues[spacing] || spacingValues.none;

  const getBreakpoints = () => {
    const breakpointsLargeCard = {
      1024: {
        slidesPerView: 4,
        spaceBetween: selectedSpacing.md,
      },
      1280: {
        slidesPerView: 5,
        spaceBetween: selectedSpacing.xl,
      },
      768: {
        slidesPerView: 'auto',
        spaceBetween: selectedSpacing.sm,
      },
      420: {
        slidesPerView: 'auto',
        spaceBetween: selectedSpacing.default,
      },
    };

    const breakpoints = {
      1024: {
        slidesPerView: 4,
        spaceBetween: selectedSpacing.md,
      },
      1280: {
        slidesPerView: 5,
        spaceBetween: selectedSpacing.xl,
      },
      1536: {
        slidesPerView: 6,
        spaceBetween: selectedSpacing.xl,
      },
      2048: {
        slidesPerView: 8,
        spaceBetween: selectedSpacing.xxl,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: selectedSpacing.default,
      },
      542: {
        slidesPerView: 3,
        spaceBetween: selectedSpacing.default,
      },
    };

    return isProductCardLarge ? breakpointsLargeCard : breakpoints;
  };

  const breakpoints = getBreakpoints();

  return {
    spacingClass: spacing !== 'none' ? getClass(spacing) : null,
    breakpoints: breakpoints,
    defaultSlidePerView: isProductCardLarge ? 'auto' : 2,
    defaultSpaciBetween: selectedSpacing.default,
    spacing_between_card: spacing,
    isProductCardLargImage: isProductCardLarge,
  };
};

export { useSpacingBetweenProductCard };
